import { render, staticRenderFns } from "./InvoiceLooseSave.vue?vue&type=template&id=70904bc0"
import script from "./InvoiceLooseSave.vue?vue&type=script&lang=js"
export * from "./InvoiceLooseSave.vue?vue&type=script&lang=js"
import style0 from "./InvoiceLooseSave.vue?vue&type=style&index=0&id=70904bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports